// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oo-9";
export var arrowButtonContainer = "_oo-5";
export var arrowButtonIcon = "_oo-6";
export var carouselArrowButton = "_oo-2";
export var carouselElementContainer = "_oo-1";
export var currentSlide = "_oo-8";
export var left = "_oo-3";
export var otherSlide = "_oo-a";
export var productCarouselContainer = "_oo-0";
export var right = "_oo-4";
export var sliderOverflow = "_oo-7";